import Vue from 'vue';
import CartProductQuantity from '@/modules/product/components/ProductQuantity.vue';
export default Vue.extend({
    components: {
        CartProductQuantity,
    },
    data() {
        return {
            quantity: 1,
        };
    },
    methods: {
        onQuantitySelected(newQuantity) {
            this.quantity = newQuantity;
        },
    },
});
